import { TDashboardPageData } from 'types/state';
import {
  M8AccountInfo,
  M8UserProfile,
  M8ProdStackDTO,
  M8DemoStackDTO,
} from 'services/production/types';
import { TGetDashboardPageDataParams } from 'types/services';
import { m8API } from 'services/production/m8';
import { normalizeM8DemoStackInfo } from 'services/production/utils/normalizeM8DemoStackInfo';
import { normalizeM8UserProfile } from 'services/production/utils/normalizeM8UserProfile';
import { normalizeM8AccountInfo } from 'services/production/utils/normalizeM8AccountInfo';
import { normalizeM8ProdStackDTO } from 'services/production/utils/normalizeM8ProdStackDTO';

type TM8Data = [
  M8UserProfile | void,
  M8AccountInfo | void,
  M8DemoStackDTO | null | void,
  M8ProdStackDTO | null | void
];

const toDashboardPageData = ([
  m8UserProfile,
  accountInfo,
  demoStackInfo,
  prodStackInfo,
]: TM8Data): TDashboardPageData => ({
  activeSubscriptions: undefined, // TODO: еще не реализовано на стороне сервера.
  prodStackStatus: 'MISSING',
  prodStackInfo: prodStackInfo
    ? normalizeM8ProdStackDTO(prodStackInfo).toDashboardProdStackInfo()
    : undefined,
  demoStackInfo:
    demoStackInfo && m8UserProfile
      ? normalizeM8DemoStackInfo(demoStackInfo).toDashboardDemoStackInfo(
          m8UserProfile
        )
      : undefined,
  payments: undefined, // TODO: еще не реализовано на стороне сервера.
  accountInfo: accountInfo
    ? normalizeM8AccountInfo(accountInfo).toUserAccountInfo()
    : undefined,
  profileInfo: m8UserProfile
    ? normalizeM8UserProfile(m8UserProfile).toUserProfileInfo()
    : undefined,
});

export const getDashboardPageData = async (
  params: TGetDashboardPageDataParams
) => {
  const { userRoles } = params;

  const [
    m8UserProfile,
    accountInfo,
    demoStackInfo,
    prodStackInfo,
  ] = await Promise.all([
    userRoles.includes('CLIENT')
      ? m8API.user.getQuestionnaireInfo()
      : Promise.resolve(undefined),
    m8API.user.getAccountInfo(),
    userRoles.includes('CLIENT')
      ? m8API.user.getDemoStackInfo()
      : Promise.resolve(undefined),
    userRoles.includes('CLIENT')
      ? m8API.user.getProdStackInfo()
      : Promise.resolve(undefined),
  ]);

  return toDashboardPageData([
    m8UserProfile,
    accountInfo,
    demoStackInfo,
    prodStackInfo,
  ]);
};
